/* eslint-disable camelcase */
const googleCalendarPermissions = "https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/calendar.events";
const microsoftCalendarPermissions = "Calendars.ReadWrite MailboxSettings.Read";

/** @see https://auth0.github.io/auth0-spa-js/interfaces/redirectloginoptions.html **/
export const googleStandardOptions = {
	connection: "google-oauth2",
	scope: "openid profile email read:current_user read:user_idp_tokens",
	prompt: "select_account",
};

export const googleCalendarOptions = {
	connection_scope: googleCalendarPermissions,
};

/** @see https://auth0.github.io/auth0-spa-js/interfaces/redirectloginoptions.html **/
export const msStandardOptions = {
	connection: "microsoft-oauth",
	scope: "openid profile email User.Read read:current_user read:user_idp_tokens",
	prompt: "select_account",
};

export const msCalendarOptions = {
	connection_scope: microsoftCalendarPermissions,
};

/** @see https://auth0.github.io/auth0-spa-js/interfaces/redirectloginoptions.html **/
export const emailStandardOptions = {
	connection: "Username-Password-Authentication",
	scope: "openid profile email User.Read read:current_user read:user_idp_tokens", // ?
	prompt: "login",
};
